import { render, staticRenderFns } from "./learningmapdetil.vue?vue&type=template&id=5794bdce&scoped=true"
import script from "./learningmapdetil.vue?vue&type=script&lang=js"
export * from "./learningmapdetil.vue?vue&type=script&lang=js"
import style0 from "./learningmapdetil.vue?vue&type=style&index=0&id=5794bdce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794bdce",
  null
  
)

export default component.exports